<template>
  <div class="report-kpis card-list">
    <article class="card card--with-icon report-kpi">
      <div class="card-icon-wrap">
        <i class="material-icons">request_quote</i>
      </div>
      <div class="card-content">
        <span class="report-kpi-value">{{ formatBrl(totals.expected) }}</span>
        <p class="card-meta card-secondary">Total esperado</p>
      </div>
    </article>
    <article class="card card--with-icon report-kpi">
      <div class="card-icon-wrap">
        <i class="material-icons">payments</i>
      </div>
      <div class="card-content">
        <span class="report-kpi-value">{{ formatBrl(totals.paid) }}</span>
        <p class="card-meta card-secondary">Total pago</p>
      </div>
    </article>
    <article class="card card--with-icon report-kpi">
      <div class="card-icon-wrap report-kpi-icon-fee">
        <i class="material-icons">percent</i>
      </div>
      <div class="card-content">
        <span class="report-kpi-value">{{ formatBrl(totals.fees) }}</span>
        <p class="card-meta card-secondary">Total taxas</p>
      </div>
    </article>
    <article class="card card--with-icon report-kpi">
      <div class="card-icon-wrap report-kpi-icon-net">
        <i class="material-icons">account_balance_wallet</i>
      </div>
      <div class="card-content">
        <span class="report-kpi-value">{{ formatBrl(totals.net) }}</span>
        <p class="card-meta card-secondary">Total líquido</p>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'ReportKPIs',
  props: {
    totals: {
      type: Object,
      required: true,
      validator: (value) =>
        value.expected !== undefined &&
        value.paid !== undefined &&
        value.fees !== undefined &&
        value.net !== undefined
    },
    formatBrl: {
      type: Function,
      required: true
    }
  }
};
</script>

<style scoped>
.report-kpis {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--space-sm);
  margin-bottom: var(--space-xl);
}

.report-kpi {
  margin: 0;
  grid-template-columns: auto 1fr;
  grid-template-areas: "icon content";
}

.report-kpi .card-content {
  min-width: 0;
}

.report-kpi-value {
  display: block;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--color-text);
  margin-bottom: 2px;
  font-variant-numeric: tabular-nums;
}

.report-kpi-icon-fee {
  background: var(--color-error-bg);
  color: var(--color-error);
}

.report-kpi-icon-net {
  background: var(--color-accent-soft);
  color: var(--color-accent);
}

@media (max-width: 560px) {
  .report-kpis {
    grid-template-columns: 1fr;
  }
}
</style>
